<div class="modal-backdrop" *ngIf="show" (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="text-center">
          <!-- Publish Icon -->
          <div class="publish-icon-container mb-4">
            <div class="publish-icon-background">
              <i class="fas fa-upload"></i>
            </div>
          </div>

          <!-- Main Message -->
          <h5 class="modal-title mb-3">
            Are you sure you want to publish the template "{{ templateName }}"?
          </h5>

          <!-- Info Message -->
          <p class="info-message text-muted">
            Once published, this template will be available<br />
            for use by service managers to create new services.<br />
            You can unpublish it later if needed.
          </p>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="onCancel()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">
          Yes, Publish
        </button>
      </div>
    </div>
  </div>
</div>
